import { useTranslation } from 'react-i18next';

interface SlotParticipantDetailProps {
  participantNames: string[];
  availableNames: string[];
  currentParticipantName: string | null;
  isOpen: boolean;
}

export function SlotParticipantDetail({
  participantNames,
  availableNames,
  currentParticipantName,
  isOpen,
}: SlotParticipantDetailProps) {
  const { t } = useTranslation();
  const availableSet = new Set(availableNames);

  const ordered = [...participantNames].sort((a, b) => {
    const aFree = availableSet.has(a) ? 0 : 1;
    const bFree = availableSet.has(b) ? 0 : 1;
    if (aFree !== bFree) return aFree - bFree;
    if (a === currentParticipantName) return -1;
    if (b === currentParticipantName) return 1;
    return a.localeCompare(b);
  });

  if (!isOpen) return null;

  return (
    <div className="mt-3.5 flex flex-col gap-2 border-t border-room-border pt-3">
      {ordered.map(name => {
        const isFree = availableSet.has(name);
        const isYou = name === currentParticipantName;
        return (
          <div
            key={name}
            className={`flex items-center gap-2 text-[13px] ${isFree ? '' : 'busy-row'}`}
          >
            <span
              className={`h-[7px] w-[7px] shrink-0 rounded-full ${isFree ? 'bg-room-accent' : 'bg-room-text-faint'}`}
            />
            <span
              className={`flex-1 font-semibold ${isFree ? '' : 'font-medium text-room-text-faint'}`}
            >
              {name}
              {isYou ? ` (${t('common.you').toLowerCase()})` : ''}
            </span>
            <span
              className={`text-[11px] font-bold uppercase tracking-wide ${
                isFree ? 'text-room-accent' : 'text-room-text-faint'
              }`}
            >
              {isFree
                ? t('leaderboard.free', { defaultValue: 'Free' })
                : t('leaderboard.busy', { defaultValue: 'Busy' })}
            </span>
          </div>
        );
      })}
    </div>
  );
}
